<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  {{data.message}}
</mat-dialog-content>
<mat-dialog-actions align="end" class="action-container">
  <button mat-raised-button color="warn" mat-dialog-close cdkFocusInitial>Nein</button>
  <button mat-raised-button color="success" mat-warn [mat-dialog-close]="true">Ja</button>
</mat-dialog-actions>
